<template id="video">
  <video playsinline="" autoplay="" muted="" loop="" poster="/images/poster.png">
<!--
    <source src="https://coverr.co/s3/webm/blurry-night.webm" type="video/webm">
    <source src="https://coverr.co/s3/mp4/blurry-night.mp4" type="video/mp4">
-->
    <source src="images/bg.webm" type="video/webm">
    <source src="images/bg.mp4" type="video/mp4">
  </video>
</template>

<script>

export default {
  name: 'video',
  data () {
    return {
    }
  },
  components: {
  },
  mounted: function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Video.vue